import React, { ReactNode, RefObject } from "react";
import { get } from "lodash";
import { Cabinet as CabinetFragment } from "@sonder/ui/source/styled/fragments/Cabinet";

interface CabinetProps {
  children: ReactNode;
  className?: string;
  offsetNode?: RefObject<HTMLElement>;
}

export const Cabinet = ({ children, className, offsetNode }: CabinetProps) => {
  const left = get(offsetNode, "current.offsetWidth", 0);
  return (
    <CabinetFragment className={className} left={`${left}px`}>
      {children}
    </CabinetFragment>
  );
};
